import React, { useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import Tooltip from "@/Components/Tooltip";
const ShrinkableDashboardFilterItems = ({
  items,
  showMinimumTags = 0,
  gap = "gap-8",
}) => {
  if (!items) return null;

  const [hiddenItems, setHiddenTags] = useState(0);
  const rowRef = useRef(null);
  const itemRefs = useRef([]);

  const calculateTags = () => {
    const hiddenTagWidth = 45;
    let rowWidth = rowRef.current?.offsetWidth;
    let itemsWidth = 0;
    let hiddenCount = 0;

    itemRefs.current.forEach((ref, i) => {
      if (ref) {
        itemsWidth += ref.offsetWidth + 32;
        if (itemsWidth > rowWidth - hiddenTagWidth) {
          hiddenCount++;
        }
      }
    });

    if (items.length - hiddenCount < showMinimumTags) {
      hiddenCount = items.length - showMinimumTags;
    }

    setHiddenTags(hiddenCount);
  };

  useEffect(() => {
    itemRefs.current = itemRefs.current.slice(0, items.length);
    calculateTags();
  }, [items]);

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      calculateTags();
    }, 50);

    window.addEventListener("resize", debouncedHandleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  return (
    <div className="flex max-w-full grow max-sm:hidden" ref={rowRef}>
      <div className={`flex max-w-full items-center ${gap}`}>
        {items &&
          items.map((item, i) => {
            let isHiddenItem =
              hiddenItems > 0 && i === items.length - hiddenItems;
            // Get all the items that are hidden
            let hiddenItemsNames = items
              .slice(i, i + hiddenItems)
              .map((item) => item.name);

            return (
              <div
                className="flex-shrink-0"
                key={i}
                ref={(el) => (itemRefs.current[i] = el)}
                style={
                  i < items.length - hiddenItems || isHiddenItem
                    ? { visibility: "visible" }
                    : { visibility: "hidden" }
                }
              >
                {isHiddenItem ? (
                  <Tooltip
                    tooltipText={hiddenItemsNames.join(", ")}
                    position="bottom"
                  >
                    <p className="cursor-help">
                      +{hiddenItems}
                      <span className="invisible -ml-8">{item.name}</span>
                    </p>
                  </Tooltip>
                ) : (
                  item.html || item.name
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ShrinkableDashboardFilterItems;
